import React from "react";

const PlusIcon: React.FC = () => {
  return (
    <div
      // className="prod_count_min glyphicon glyphicon-minus-sign"
      className="circle-icon-plus "
    >
      <svg
        data-v-54a96833=""
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 384 512"
        fill="currentColor"
        data-spec="icon-minus"
        className="w-5 h-5"
        style={{ width: 14, height: 14 }}
      >
        <path
          fill="currentColor"
          d="M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"
        ></path>
      </svg>

      {/* <span className="glyphicon glyphicon-minus-sign"></span> */}
    </div>
  );
};

export default PlusIcon;
